import $ from 'jquery';

const sliderGalleryFor = () => {
    	// Blocco Slider 2 - immagine in evidenza
	$('.gallery-for').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: '.gallery-nav'
	});
}
export default sliderGalleryFor;